<script>
export default {
    name: 'Special_Announcement',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            centerDialogVisible: this.visible,
            isTermsAccepted: true
        }
    },
    watch: {
        visible (newVal) {
            this.centerDialogVisible = newVal
        }
    },
    methods: {
        handleAgree () {
            this.$emit('update:status', true)
        },
        handleDisagree () {
            this.$emit('update:status', false)
        }
    }
}
</script>

<template>
    <el-dialog
        :visible.sync="centerDialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        custom-class="announce"
        destroy-on-close
        center
        @close="handleAgree"
    >
        <div
            slot="title"
            class="announce-header"
        >
            关于《平台服务费率调整》更新通知
        </div>
        <div class="announce-body">
            <p>首先感谢贵公司一直以来对我金穗智管平台的信任和支持！</p>
            <p class="content-text">
                根据相关部门对平台招商政策的调整，结合国务院令2025年第810号《互联网平台企业涉税信息报送规定》、国家税务总局公告2025年第15号和16号的相关要求，我平台对系统功能作了对应的升级、对服务流程和内容等作了进一步的优化，平台的经营成本随之大幅上涨。因政策变动相关原因，同时也为了能继续给贵公司提供优质的服务，我们不得不把我平台的服务费率调整为8.0%。
            </p>
            <p class="content-text">
                根据我们于2025年4月1日签订的合同编号为第YJ250401001号《会员注册协议》中“本平台有权修改本协议正文及相关规则，修改内容将在实施前七日在本平台予以公示。如会员不同意相关修改，应当停止使用并退出本平台，不影响协议修改前已发生义务及责任的承担。一旦会员继续使用本平台，则表示已接受并自愿遵守经修订后的条款。”的约定，如果贵公司对此次服务费率调整没有异议，欢迎贵公司在本月内联系我平台服务对接工作人员签订新政策下的企业会员注册协议并继续使用我平台；若贵公司对于调整后的服务费率不认可，应当停止使用并退出我平台。
            </p>
            <p class="content-text">
                本次修改内容公示期限为七天，公示期满后，我平台将对于服务费率进行调整，若贵公司继续使用本平台，则视为对调整后的费率予以认可。
            </p>
            <p class="content-text">
                特此告知
            </p>
        </div>
        <div
            slot="footer"
        >
            <p style="line-height: 1.2;margin-block-start: 1em;font-size: 14px;">
                天津远景网络科技有限公司
                <br>
                <strong>2025年9月15日</strong>
            </p>
        </div>
    </el-dialog>
</template>

<style scoped lang="scss">

</style>
